import { ReportSummaryEnum, } from "@/common/types/enum";

export const report = {
    types: {
        summary: {
            [ReportSummaryEnum.EMPTY]: "Página em branco",
            [ReportSummaryEnum.FRONT_COVER]: "Capa",
            [ReportSummaryEnum.BACK_COVER]: "Contra Capa",
            [ReportSummaryEnum.SUMMARY]: "Sumário",
            [ReportSummaryEnum.COMPANY]: "Dados da Empresa",
            [ReportSummaryEnum.EVALUATION]: "Dados da Avaliação",
            [ReportSummaryEnum.ANALYSIS]: "Análises",
            [ReportSummaryEnum.SIGNS]: "Assinaturas",
            [ReportSummaryEnum.APPEND]: "Anexos",
            [ReportSummaryEnum.TEXT]: "Texto",
            [ReportSummaryEnum.METHODS]: "Métodos",
        },
    },
    labels: {
        structure: "Estrutura",
        third_party: "Empresa Terceirizada",
        search_evaluation: "Adicionar Avaliação",
        search_company: "Buscar Empresa",
        place_of_visit: "Local de Visita",
        cnae: "CNAE",
        cnae_full: "Código Nacional de Atividade Econômica (CNAE)",
        number_of_employees: "Número de Funcionários",
        degree_of_risk: "Grau de Risco",
        analysis_total: "Total de Análises",
        canceled_analysis: "Análises Canceladas",
        complete_analysis: "Análises Completas",
        pending_analysis: "Análises Pendentes",
        crew_total: "Equipe Alocada",
        employe_total: "Funcionários Avaliados",
        employee: "Funcionário",
        equipment_total: "Equipamentos Utilizados",
        sample_total: "Amostras Utilizadas",
        analyse_data: "Dados da Análise",
        evaluation: "Avaliação",
        analyse: "Análise",
        status: "Status",
        technical: "Técnico",
        assistant: "Assistente",
        elapsed_time: "Tempo Decorrido",
        start: "Início",
        termination: "Término",
        pauses: "Pausas",
        motive: "Motivo",
        description: "Descrição",
        name: "Nome",
        social_name: "Nome Social",
        document: "Documento",
        role: "Cargo",
        sector: "Setor",
        registration_number: "Número de Matrícula",
        registration: "Matrícula",
        start_date: "Vínculo Início",
        end_date: "Vínculo Fim",
        ges_name: "GES Nome",
        ges_status: "GES Status",
        ges_description: "GES Descrição",
        method: "Método",
        code: "Código",
        field_memory: "Memória de Campo",
        brand: "Marca",
        model: "Modelo",
        serial_number: "Número de Série",
        fabrication_date: "Data de Fabricação",
        validity_date: "Data de Validade",
        equipment: "Equipamento",
        sample: "Amostra",
        signs: "Assinaturas",
        photo: "Foto",
        photos: "Fotos",
        date: "Data",
        current: 'Atual',
        bond: "Vínculo",
        end: "Término",
        cancellation: "Cancelamento",
        reason_cancellation: "Motivo do Cancelamento",
        date_cancellation: "Data do Cancelamento",
        next_calibration: "Próxima Calibração",
    },
    titles: {
        field_memory: "Memória de Campo",
        company: "Dados da Empresa",
        methods: "Métodos Utilizados",
        samples: "Amostras Utilizadas",
        equipments: "Equipamentos Utilizados",
        employee: "Funcionário",
        analyse: "Dados da Análise",
        evaluation: "Dados da Avaliação",
        signatures: "Assinaturas da Analise",
    },
    modal: {
        titles: {
            del_evaluation: "Remover avaliação",
            del_summary: "Remover Sumário",
            del_third_company: "Remover Empresa Terceirizada",
        },
        messages: {
            del_evaluation: "Deseja <strong>REMOVER</strong> esta <strong>AVALIAÇÃO</strong>?<br/>Essa operação não poderá ser desfeita!",
            del_summary: "Deseja <strong>REMOVER</strong> este <strong>ITEM</strong> do sumário?<br/>Essa operação não poderá ser desfeita!",
            del_third_company: "Deseja <strong>REMOVER</strong> esta <strong>EMPRESA TERCEIRIZADA</strong>?<br/>Essa operação não poderá ser desfeita!",
        },
    },
    texts: {
        summary_empty: "Você ainda não adicinou um <strong>ITEM</strong> ao sumário!",
        evaluation_empty: "Você ainda não vinculou uma <strong>AVALIAÇÃO</strong> ao relatório!",
        third_company_empty: "Você ainda não vinculou uma empresa terceirizada ao relatório!",
        empty_pause: "Esta análise não possui Pausas",
        empty_employee: "Esta análise não possui um Funcionário",
        empty_form: "Esta análise não possui um Formulário",
        empty_method: "Esta análise não possui um Método",
        empty_equipment: "Esta análise não possui Equipamento",
        empty_sample: "Esta análise não possui uma Amostra",
        empty_sign: "Esta análise não possui Assinaturas",
        empty_photo: "Esta análise não possui Foto",
    },
};
